import { render } from "./MonitorScreenshot.vue.js?vue&type=template&id=cdce24de!=!../vue-loader/dist/index.js??ruleSet[0]!./MonitorScreenshot.vue?vue&type=template&id=cdce24de"
import script from "./MonitorScreenshot.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./MonitorScreenshot.vue?vue&type=script&lang=js"
export * from "./MonitorScreenshot.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./MonitorScreenshot.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__